import TEPopup from './TEPopup';

export default TEPopup;
